var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { show: _vm.messageData.show }, attrs: { id: "messagebox" } },
    [
      _c("div", { staticClass: "messagebox_main" }, [
        _c("div", {
          staticClass: "text",
          domProps: { innerHTML: _vm._s(_vm.messageData.text) },
        }),
        _c("div", { staticClass: "btns" }, [
          _c("p", { on: { click: _vm.close } }, [
            _vm._v(
              _vm._s(
                _vm.messageData.left_btn ? _vm.messageData.left_btn : "取消"
              )
            ),
          ]),
          _c("p", { on: { click: _vm.determine } }, [
            _vm._v(
              _vm._s(
                _vm.messageData.right_btn ? _vm.messageData.right_btn : "确定"
              )
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }